export const iconFontAwesomeDevicesHardwareCompactDisc = (
	<i className="fa-solid fa-compact-disc"></i>
);
